import { createFileRoute, redirect } from "@tanstack/react-router";
import { AuditForm } from "@/features/audits/AuditForm";
import { useCurrentUser, currentUserQueryOptions } from "@/hooks/useCurrentUser";
import { canCreateAudit } from "@/lib/roles";

export const Route = createFileRoute("/_authenticated/audits/new")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateAudit(me.roles)) throw redirect({ to: "/audits" });
  },
  component: NewAuditPage,
});

function NewAuditPage() {
  const { data: me } = useCurrentUser();
  if (!me) return null;
  if (!canCreateAudit(me.roles)) {
    return (
      <div className="mx-auto max-w-xl rounded-lg border bg-card p-6">
        <h1 className="text-lg font-semibold">Permission required</h1>
        <p className="mt-2 text-sm text-muted-foreground">You do not have permission to create audits.</p>
      </div>
    );
  }
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">New Audit Cycle</h1>
      <AuditForm />
    </div>
  );
}
